module.exports = __webpack_public_path__ + "static/media/zuk_farm_thumb.3bd00967.jpg";